export const mainRoutes = [ 'overview', 'expenses', 'goals' ];
export const userMenuRoutes = [ 'my-account', 'my-institutions', 'security', 'subscription', 'support' ];
export const adminRoutes = [ 'admin-dashboard' ];